import React from 'react'
import { ClassementPopulated } from '../types'
import style from './style.module.scss'
import { DisplayEquipe } from '../../components/DisplayEquipe'
import { MonClubLink } from '../../components/MonClubLink'
import { booleanBitStringToBoolean } from '../../shared/utils'

export const MiniClassementLine = ({ classement }: { classement: ClassementPopulated }) => {
    return (
        <tr>
            <td>{classement.place}</td>
            <td className={style.club}>
                <MonClubLink
                    extStructureId={classement.ext_structureId}
                    disableLink={!booleanBitStringToBoolean(classement.equipe_logoActif)}
                >
                    <DisplayEquipe
                        libelle={classement.equipe_libelle}
                        displayLogo={booleanBitStringToBoolean(classement.equipe_logoActif)}
                        logo={classement.structure_logo}
                        size="small"
                    />
                </MonClubLink>
            </td>
            <td className={style.totalPoint}>{classement.point}</td>
        </tr>
    )
}
